import {Component, Inject} from '@angular/core';
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {SnackbarService} from "../../../services/snackbar.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {PlayersService} from "../../../services/players.service";
import {IDeactivatePlayerNumbers} from "../../../interfaces/player/IDeactivatePlayerNumbers";
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {MatCheckbox} from "@angular/material/checkbox";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {SelectionModel} from "@angular/cdk/collections";
import {IGoldRushStrip} from "../../../interfaces/IGoldRushStrip";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";


@Component({
  selector: 'app-deactivate-player-numbers',
  standalone: true,
  templateUrl: './deactivate-player-numbers.component.html',
  imports: [
    DialogBaseComponent,
    MatCheckbox,
    FormsModule,
    MatButton,
    MatTableModule
  ],
  styleUrls: ['./deactivate-player-numbers.component.css']
})
export class DeactivatePlayerNumbersComponent {
  public uiState: UIStateEnum = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;
  public activeNumbers: IGoldRushStrip[] = [];
  selectedStripsForDeactivation = new SelectionModel<IGoldRushStrip>(true, []);
  activeStripsDataSource = new MatTableDataSource<IGoldRushStrip>();
  displayedColumns: string[] = ['Select', 'Id', 'TicketNumbers'];

  constructor(private snackBarService: SnackbarService,
              private errorHandlingService: ErrorHandlingService,
              private playersService: PlayersService,
              private matDialogRef: MatDialogRef<DeactivatePlayerNumbersComponent>,
              @Inject(MAT_DIALOG_DATA) public deactivateRequestData: {
                PlayerId: string;
                Game: IGameQueryResult;
                AllPlayerTickets: IGoldRushStrip[]
              }) {
    this.activeNumbers = this.deactivateRequestData.AllPlayerTickets.filter((stripP) => stripP.Active);
    this.activeStripsDataSource.data = this.activeNumbers;
  }

  getNumbersString(numbersP: number[]): string {
    return numbersP.join(', ');
  }

  isAllSelected() {
    const numSelected = this.selectedStripsForDeactivation.selected.length;
    const numRows = this.activeStripsDataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selectedStripsForDeactivation.clear();
      return;
    }

    this.selectedStripsForDeactivation.select(...this.activeStripsDataSource.data);
  }

  deactivateNumbers() {
    let deactivationRequest: IDeactivatePlayerNumbers | null;

    deactivationRequest = this.buildDeactivateGoldRushStripsRequest();

    if (deactivationRequest) {
      this.uiState = UIStateEnum.ShowLoading;

      this.playersService.deactivatePlayerNumbersByGroup(deactivationRequest).subscribe({
        next: () => {
          this.matDialogRef.close(true);
        },
        error: (err) => {
          this.uiState = UIStateEnum.ShowData;
          this.errorHandlingService.displayDialogLevelErrorMessage(err, true);
        }
      })
    }

  }

  buildDeactivateGoldRushStripsRequest(): IDeactivatePlayerNumbers | null {
    const strip_ids = this.selectedStripsForDeactivation.selected.flatMap((strip) => strip.Id)

    if (strip_ids.length > 0) {
      return {
        GoldRushStripIds: strip_ids,
        PlayerId: this.deactivateRequestData.PlayerId,
        GameId: this.deactivateRequestData.Game.Id
      }
    }

    this.snackBarService.openErrorSnackBar('you must select at least one strip to deactivate')
    return null;
  }
}
